import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import "../../scss/v2/legal.scss"

function Warranty(props) {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(props.lang);
    }, [i18n, props.lang])

    return (
        <div className="legal container">
            <Helmet>
                <title>{t("meta.title.warranty")}</title>
                <meta name="description" content={t("meta.description.warranty")} />
                <meta name="robots" content="noindex" />
            </Helmet>
            <h1 className="legal-title">{t('legal.warranty.title')}</h1>
            <div className="legal-text" dangerouslySetInnerHTML={{ __html: t('legal.warranty.text') }}  />
        </div>
    )

}

export default Warranty